import React from "react";

export const Page2Tamil = () => {
  return (
    <div className="page-tamil-container">
      <h1>தென் திசையில் : </h1>
      <p>
        ஆதியில் கைச் சின்னம் என்று அழைக்கப்பட்ட கச்சனத்தில் இந்திரனால்
        பூஜிக்கப்பட்ட ஸ்ரீகைச் சின்னேஸ்வரர் ஆலயம் உள்ளது.
      </p>
      <h1>கிழக்கு திசையில் : </h1>
      <p>
        ஆதியில் திருக்கோளிலி என்று அழைக்கப்பட்ட திருக்குவளையில் பாடல் பெற்ற
        கோளிலியப்பர் ஆலயம் உள்ளது.
      </p>
      <h1>மேற்கு திசையில் </h1>
      <p>
        ஆதியில் நெல்லிவனம் என்று அழைக்கப்பட்ட திருநெல்லிக்காவலில் நெல்லிவன நாதர்
        என்ற ஆலயம் உள்ளது.
      </p>
      <p>
        மேலே குறிப்பிட்ட நான்கு புண்ணிய தலங்களுமே கொளப்பாடு கிராம
        எல்லையிலிருந்து சுமார் அரை கிலோ மீட்டர் தொலைவிலேயே உள்ளது. நான்கு
        திசைகளிலும் புண்ணிய ஸ்தலங்கள் அமைந்துள்ளதால் நடுநாயகமாய் அமைந்த
        <strong>கொளப்பாடும்</strong> ஒரு புண்ணிய ஸ்தலமாகும்.
      </p>
      <h1>ஊரும் பெயரும் : </h1>
      <p>
        தற்சமயம் சிவன் ஆதியண்ணன், அய்யனார் ஆலயங்கள் அமைந்துள்ள இடம்
        முற்காலத்தில் புல்வெளியாக இருந்துள்ளது. பசுமாடுகள் அவ்விடம் மேய்வது
        வழக்கம். ஒரு நாள் அதிக மழை பெய்து பூமி சேறாக இருந்துள்ளது. பசுமாடு ஒன்று
        சேற்றுக்குள் காலை விட்டது. அதன் கால் குளம்பு பதிந்த இடத்தில் ஒரு
        சிவலிங்கம் இருந்துள்ளது. லிங்கத்தின் தலைபாகத்தில் மாட்டின் குளம்பு
        படிந்துள்ளது. இதைப்பார்த்த மக்கள் சிவலிங்கத்தை எடுத்து குளம்படி நாதர் என
        பெயரிட்டு சிறு கோயில்கட்டி வணங்கி வந்துள்ளார்கள். பின்னர் ஊரும் கொளம்படி
        என்ற பெயரோடு வழங்கி பிற்காலத்தில் கொளப்பாடு என்று பெயர் உண்டாயிற்று
        என்பது செவிவழிச் செய்தியாகும். ஆயினும் இதை உறுதிப்படுத்தும் வகையில்
        குளப்பாட்டில் சிவன் கோயிலில் அமைந்துள்ள சிவலிங்கத்தின் தலைபாகத்தில்
        மாட்டின் குளம்பு படிந்திருப்பதை இன்றும் காணலாம்.
      </p>
      <p>
        "கோயில் இல்லா ஊரில் குடியிருக்க வேண்டாம்" என்பது முதுமொழி. கொளப்பாடு
        கிராமத்தில் தெருவுக்கு ஒரு கோயில் என்று சொல்கின்ற வகையில் கடைத்தெருவில்
        ஸ்ரீ செல்லமுத்து மாரியம்மன் கோயில் விநாயகர் கோயில் - காசி விஸ்வநாதர்
        கோயில் என்று பல கோயில்கள் உள்ளது. இரு பிடாரிகளின் விக்ரகங்கள் உள்ள
        பிடாரி கோயிலும் உண்டு.
      </p>
      <p style={{margin:0}}>
        மாரியம்மன் கோயிலில் சித்திரைத் திருவிழாவும், சிவன் கோயிலில் வைகாசி
        விசாகத் திருவிழாவும் மிகச் சிறப்பாக நடைபெறுகிறது - தேரோட்டம்,
        தெப்பம்,தீமிதி, பஞ்சமூர்த்திகள் வீதியுலாவும் சிறப்பாக கிராம மக்களால்
        கொண்டாடப்படுகிறது.
      </p>
    
    </div>
  );
};
